module.exports = __webpack_public_path__ + "img/2-en.f544aa20.jpg";